import React, { useState, useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { fetchCards, addCard } from 'api';
import { Modal, SingleButtonControls, SettingsControls, WordCard, NavigationButtons, TextInput, BackgroundWrapper } from 'components';
import { useExtendedMutation } from 'mutations';
import { useAuth } from "react-oidc-context";

const FlashcardPage = () => {
  const auth = useAuth();

  const [openModal, setOpenModal] = useState(false);
  const [words, setWords] = useState([]);
  const [wordIndex, setWordIndex] = useState(0);
  const [userTextInput, setUserTextInput] = useState('');
  const [newWord, setNewWord] = useState('');

  const token = auth.user?.access_token;

  const getCardsSuccessCallback = (data) => {
    console.log(data[0]);
    setWords(data);
  }

  const addCardSuccessCallback = (data) => {
    setNewWord('');
    console.log([...words, data]);
    setWords([...words, data]);
  }

  const errorCallback = (error) => {
    console.log(error); //TODO add proper error handling
  }

  const getCardsMutation = useExtendedMutation(fetchCards, getCardsSuccessCallback, errorCallback);
  const addCardMutation = useExtendedMutation(addCard, addCardSuccessCallback, errorCallback);

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      getCardsMutation.mutateOnVirtualThread({ token: token });
    }
  }, [auth.isAuthenticated, auth.user]);

  const incrementWordIndex = () => {
    setWordIndex((prevIndex) => (prevIndex + 1) % words.length);
  };

  const handleAddWord = () => {
    if (userTextInput.trim() !== '') {
      if (newWord) {
        addCardMutation.mutateOnVirtualThread({word: newWord, definition: userTextInput, token: token});
      }
      else {
        setNewWord(userTextInput);
      }
      setUserTextInput('');
    }
  };

  const handleInputChange = (event) => {
    setUserTextInput(event.target.value);
  };

  const handleInputKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleAddWord();
    }
  };

  if (auth.isAuthenticated && auth.user) {
      const token = auth.user?.access_token;

      return (
        <>
          {/* <SingleButtonControls buttonText={"Settings"} onClick={() => setOpenModal(true)} /> */}
          <Modal isOpen={openModal} onClose={() => setOpenModal(false)} onClick={() => {}}>
              <SettingsControls token={token}/>
          </Modal>
          <BackgroundWrapper>
            <WordCard word={words[wordIndex]?.word}/>
            <TextInput
              value={userTextInput}
              callbackOnChange={handleInputChange}
              callbackOnKeyPress={handleInputKeyPress}
              placeholder={newWord ? "Add definition" : "Add word"}
            />
            <NavigationButtons 
              callbackLeft={() => incrementWordIndex()}
              callbackRight={() => incrementWordIndex()}
            />
          </BackgroundWrapper>
        </>
      )
  } else 
  {
    return(<div></div>)
  }
};

export { FlashcardPage }